import React, { useState, useEffect, useRef } from 'react';
import services from '../../services';
const PROPERTY_TYPES = [
    { value: 'Status', icon: '▶️' },
    { value: 'Tag', icon: '🏷️' },
];
const PropertySettingsModal = ({
    show,
    onClose,
    onSave,
    selectedBoardId,
    className = '',
    getPropertyByID,
    setShowPropertyModal,
    selectedColumnField,
    onDelete,
    position = { top: 0, left: 0 },
}) => {
    const [type, setType] = useState('');
    const [name, setName] = useState('');
    const [displayOnCard, setDisplayOnCard] = useState(false);
    const [propertyId, setPropertyId] = useState(null);
    const modalRef = useRef(null);
    
    useEffect(() => {
        function handleClickOutside(event) {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        }
        if (show) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [show, onClose]);

    if (!show) return null;
    const handleSave = async () => {
        try {
            const propertyType = PROPERTY_TYPES.find((opt) => opt.value === type);
            const isUpdate = !!propertyId;
            const data = {
                property: {
                    name: propertyType?.value,
                    icon: propertyType?.icon,
                    value: null,
                    propertyName: name,
                },
                boardId: selectedBoardId,
                isVisible: displayOnCard,
            };
            if (isUpdate) {
                const resUpdate = await services?.property?.UPDATE_PROPERTY(propertyId, data);
            } else {
                const res = await services?.property?.CREATE_PROPERTY(data);
            }
            getPropertyByID(selectedBoardId);
            setDisplayOnCard(false);
            setShowPropertyModal(false);
        } catch (error) {
            console.error('Failed to add property:', error);
        }
    };

    useEffect(() => {
        if (show && selectedColumnField?.property) {
            const { name: typeName, propertyName } = selectedColumnField.property;
            setType(typeName || '');
            setName(propertyName || '');
            setDisplayOnCard(false);
            setPropertyId(selectedColumnField.id);
        }
    }, [show, selectedColumnField]);
    if (!show) return null;
    return (
        <div
            ref={modalRef}
            className={`absolute right-0 top-full mt-2 z-50 bg-white border border-gray-200 rounded-md shadow-md w-[300px] p-4 text-[13px] text-black font-google ${className}`}
        >
            <div className="flex justify-between items-center mb-2 mt-2">
                <h2 className="text-[12px] font-bold uppercase text-black tracking-wide">Property Settings</h2>
                <div className="flex items-center gap-2">
                    <button
                        onClick={() => {
                            if (selectedColumnField && selectedColumnField.id) {
                                onDelete?.(selectedColumnField.id);
                            }
                            setShowPropertyModal(false);
                        }}
                        title="Delete Property"
                        className="text-gray-500 hover:text-red-600"
                    >
                        <i className="bi bi-trash text-[16px]"></i>
                    </button>
                </div>
            </div>
            <div className="mb-3">
                <label className="block text-[11px] font-bold uppercase text-gray-700 mb-1 text-left">Type</label>
                <select
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                    className="w-full border border-gray-300 rounded-md px-2 py-1.5 text-sm text-black focus:outline-none focus:ring focus:border-blue-400 bg-white"
                >
                    <option value="">Select type</option>
                    {PROPERTY_TYPES.map((item, idx) => (
                        <option key={idx} value={item.value}>
                            {item.icon} {item.value}
                        </option>
                    ))}
                </select>
            </div>
            <div className="mb-3">
                <label className="block text-[11px] font-bold uppercase text-gray-700 mb-1 text-left">
                    Property Name
                </label>
                <input
                    type="text"
                    placeholder="Add property name here"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className="w-full border border-gray-300 rounded-md px-2 py-1.5 text-sm text-black focus:outline-none focus:ring focus:border-blue-400 bg-white"
                />
            </div>
            <div className="mb-4 flex items-start">
                <input
                    type="checkbox"
                    id="displayOnCard"
                    checked={displayOnCard}
                    onChange={(e) => setDisplayOnCard(e.target.checked)}
                    className="mt-1 text-blue-600 form-checkbox"
                />
                <label htmlFor="displayOnCard" className="ml-2 text-[11px] font-bold text-black leading-snug">
                    DISPLAY ON CARD <span className="font-normal lowercase">(available on tags + statuses)</span>
                </label>
            </div>
            <div className="flex justify-end gap-2">
                <button
                    onClick={onClose}
                    className="px-3 py-1.5 rounded-md bg-gray-200 hover:bg-gray-300 text-sm font-semibold text-black"
                >
                    Cancel
                </button>
                <button
                    onClick={handleSave}
                    disabled={!type || !name}
                    className={`px-3 py-1.5 rounded-md text-sm font-semibold text-white ${!type || !name ? 'bg-gray-300 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-600'
                        }`}
                >
                    Save
                </button>
            </div>
        </div>
    );
};
export default PropertySettingsModal;
